/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_HelloInputs */

const en_mascot_hello = /** @type {(inputs: Mascot_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hey, let's work together!`)
};

const id_mascot_hello = /** @type {(inputs: Mascot_HelloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai, siap kerja bareng?`)
};

/**
* | output |
* | --- |
* | "Hey, let's work together!" |
*
* @param {Mascot_HelloInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_hello = /** @type {((inputs?: Mascot_HelloInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_HelloInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_hello(inputs)
	return en_mascot_hello(inputs)
});